module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', {
    staticClass: "animated fadeIn setting-container step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.settings.title')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.settings.feedback')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.show_review),
      expression: "doctor.show_review"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.doctor.show_review) ? _vm._i(_vm.doctor.show_review, null) > -1 : (_vm.doctor.show_review)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.doctor.show_review,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.doctor.show_review = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.doctor.show_review = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.doctor.show_review = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.show_feedback')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.settings.search')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group premium-feature",
    class: {
      'disable': !_vm.$guser.isPremiumAccount()
    }
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.search_active),
      expression: "doctor.search_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.$guser.isPremiumAccount()
    },
    domProps: {
      "checked": Array.isArray(_vm.doctor.search_active) ? _vm._i(_vm.doctor.search_active, null) > -1 : (_vm.doctor.search_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.doctor.search_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.doctor.search_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.doctor.search_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.doctor.search_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.search_display')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm",
    slot: "loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f32eef58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/doctor/Setting.vue
// module id = 1056
// module chunks = 1